import type { Module } from 'vuex';
import { ActionError } from '@/types/ActionError';
import {RootState} from "@/store";

export interface ActionErrorsState {
  actionErrors: ActionError[];
}

const actionErrorsModule: Module<ActionErrorsState, RootState> = {
  namespaced: true,

  state: (): ActionErrorsState => ({
    actionErrors: [],
  }),

  getters: {
    getById: (state) => (idActionError: number): ActionError | undefined => {
      return state.actionErrors.find(actionError => actionError.idActionError === idActionError);
    },
  },

  mutations: {
    setActionErrors(
      state,
      payload: { actionErrors: Record<number, any> }
    ) {
      state.actionErrors = Object
        .values(payload.actionErrors)
        .map(raw => ActionError.fromRaw(raw));
    },

    setActionErrorCreate(
      state,
      payload: {
        idActionError: number;
        idAction: number;
        name: string;
      }
    ) {
      const actionError = new ActionError(
        payload.idActionError,
        payload.idAction,
        payload.name,
        false,
      );
      state.actionErrors.push(actionError);
    },

    setActionErrorDelete(
      state,
      payload: { idActionError: number }
    ) {
      state.actionErrors = state.actionErrors.filter(
        actionError => actionError.idActionError !== payload.idActionError
      );
    },
  },

  actions: {
    wsSetActionErrors({ commit }, payload) {
      commit('setActionErrors', payload);
    },
    wsActionErrorCreate({ commit }, payload) {
      commit('setActionErrorCreate', payload);
    },
    wsActionErrorDelete({ commit }, payload) {
      commit('setActionErrorDelete', payload);
    },
  },
};

export default actionErrorsModule;
